import React from 'react';

import LoaderGif from '@components/common/LoaderGif/LoaderGif';

import style from './style.module.scss';

const Loader = () => (
  <div className={style.loaderBlock}>
    <LoaderGif />
  </div>
);

export default Loader;
